import SS from '../../../assets/landing_page/Images/Secure Sharing.png'
import IUI from '../../../assets/landing_page/Images/User Interface.png'
import CRT from '../../../assets/landing_page/Images/Report.png'
import Ben from '../../../assets/landing_page/Images/Benefits.png'
import CTA from '../../../assets/landing_page/Images/CTA.png'
import { Collab, Flexi, UpdateAndNotification } from '../../icon/Landing-Page/Icon';


export const FAQs = [
    {
        question: 'What sets this platform apart from other project management tools?',
        answer: 'Our platform enhances existing project management tools with robust, secure, and scalable features. It follows industry best practices to streamline your workflow and improve project outcomes.'
    },
    {
        question: 'How secure is my data on this platform?',
        answer: 'Our platform enhances existing project management tools with robust, secure, and scalable features. It follows industry best practices to streamline your workflow and improve project outcomes.'
    },
    {
        question: 'Can I customize to fit my specific needs?',
        answer: 'Our platform enhances existing project management tools with robust, secure, and scalable features. It follows industry best practices to streamline your workflow and improve project outcomes.'
    },
    {
        question: 'What kind of support is available?',
        answer: 'Our platform enhances existing project management tools with robust, secure, and scalable features. It follows industry best practices to streamline your workflow and improve project outcomes.'
    },
]
export const pricingData = [
    {
        title: 'Free Plan',
        text: '',
        price: '$0',
        discount: '',
        subText: 'Per user/month, billed annually',
        mainSubText: 'For your personal projects',
        subTextData: [
            {
                title: 'Feature XXX'
            },
            {
                title: 'Feature XXX'
            },
            {
                title: 'Feature XXX'
            },
        ],
        btn: 'Get Started'
    },
    {
        title: 'Plan 1',
        popular: 'Popular',
        text: '',
        price: '$45',
        discount: '',
        subText: 'Per user/month, billed annually',
        mainSubText: 'For your personal projects',
        subTextData: [
            {
                title: 'Feature XXX'
            },
            {
                title: 'Feature XXX'
            },
            {
                title: 'Feature XXX'
            },
        ],
        btn: 'Get Started'
    },
    {
        title: 'Plan 2',
        text: '',
        price: '$85',
        discount: '',
        subText: 'Per user/month, billed annually',
        mainSubText: 'For your personal projects',
        subTextData: [
            {
                title: 'Feature XXX'
            },
            {
                title: 'Feature XXX'
            },
            {
                title: 'Feature XXX'
            },
        ],
        btn: 'Get Started'
    },
    {
        title: 'Enterprise Plan',
        text: '',
        price: 'Custom',
        discount: '',
        subText: 'Per user/month, billed annually',
        mainSubText: 'For your personal projects',
        subTextData: [
            {
                title: 'Feature XXX'
            },
            {
                title: 'Feature XXX'
            },
            {
                title: 'Feature XXX'
            },
        ],
        btn: 'Get Started'
    },
]
export const CardData = [
    {
        icon: Collab,
        title: 'Improved Collaboration',
        text: 'Boost productivity and project success through seamless stakeholder collaboration and communication.'
    },
    {
        icon: UpdateAndNotification,
        title: 'Real Time Updates & Notifications',
        text: 'Stay ahead of issues with real-time updates and notifications, keeping you and your team on track.'
    },
    {
        icon: Flexi,
        title: 'Flexibility',
        text: 'Adapt to changing project needs, ensuring that your processes remain efficient and effective.'
    },
];
export const Cards = [
    {
        img: SS,
        title: 'Secure Sharing',
        text: 'Share your project schedules securely with authorized stakeholders, both within and outside your organization.',
        wd: '30%'
    },
    {
        img: IUI,
        title: 'Intuitive User Interface',
        text: 'Experience a user-friendly interface that simplifies project management. Our intuitive design helps you focus on what matters most—delivering successful.',
        wd: '30%'
    },
    {
        img: CRT,
        title: 'Comprehensive Reporting Tools',
        text: 'Access comprehensive reporting tools to gain insights into project performance and identify improvement areas.',
        wd: '30%'
    },
]
export const FPImgData = {
    img: Ben,
    opH: '413px',
    opW: '600px',
    ipH: '350px',
    ipW: '500px',
    imgh: 'auto',
    imgw: '95%',
}
export const CTAImgData = {
    img: CTA,
    opH: '553px',
    opW: '80%',
    ipH: '490px',
    ipW: '86%',
    imgh: 'auto',
    imgw: '95%',
}
